import styled from "styled-components";

import { Dialog, Typography } from "@mui/material";


export const Title = styled(Typography)`
font-size: clamp(2rem, 2vw, 2.4rem) !important;

font-family: 'Nexa-Bold' !important; 
text-align: center;
color:${({ theme }) => theme.COLORS.YELLOW} !important;
`;

export const Text = styled(Typography)`
text-align: center;
font-size: clamp(1.4rem, 2vw, 1.8rem) !important;
font-family: 'Mont-Light' !important;
color:${({ theme }) => theme.COLORS.BLUE} !important;
`;

export const ModalAviso = styled(Dialog)`
`;